import React from 'react';
import { TabButton, TabsContainer } from './Tabs.style';

export interface TabsProps<TTab extends string> {
    tabs: readonly TTab[];
    selected?: TTab;
    onSelect?(tab: TTab): void;
}

export function Tabs<TTab extends string>(props: TabsProps<TTab>) {
    const { tabs, selected, onSelect } = props;

    const tabItems = tabs.map((t) => (
        <TabButton
            key={t}
            selected={t === selected}
            onClick={() => {
                if (t === selected) {
                    return;
                }

                onSelect?.(t);
            }}
        >
            {t}
        </TabButton>
    ));
    return <TabsContainer>{tabItems}</TabsContainer>;
}
